import { Typography } from '@mui/material';
import styled from 'styled-components';

export const TimeSlot = styled(Typography)`
  font-size: 0.875rem;
`;
